import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Cropped } from 'image-crop-generator';
import Modal from 'react-modal';
import { ClipLoader } from 'react-spinners';

import { actions as studentActions } from '../../redux/modules/student';

import { fetchById } from 'redux/api/student';

import MainLayout from '../../components/MainLayout';
import Loading from '../../components/Loading';
import HeaderInside from '../../components/HeaderInside';
import ContractsModal from '../../components/ContractsModal';

import config from '../../config';

import { FormRegister, UserDataType } from './components/forms/FormRegister';
import { FormPassword, UserPassWordDataType } from './components/forms/FormPassword';

import ArrowRight from '../../img/svg/arrowRight';
import EditPen from '../../img/svg/EditPen';

import times from 'img/times.svg';

import { itemsMenu, MenuItem } from './utils';

import {
  AvatarArea,
  ButtonDeleteMenuArea,
  ButtonDeleteAccount,
  Container,
  EditAvatarItem,
  LeftBar,
  MenuItems,
  NameLetterIcon,
  Panel,
  RightArea,
  TitleItem,
  ButtonDeleteFooterArea,
  HeaderModalProfilePhoto,
  ModalUploadProfilePhoto,
  ButtonSave,
  ButtonCancel,
  ButtonsArea,
} from './styles';
import { useProfilePhoto } from 'hooks/useProfilePhoto';

function User() {
  const linkRedirectWhatsappDeleteAccount = config.REACT_APP_DEL_ACCOUNT_URL;
  const firstLoading = useRef(true);
  const location = useLocation();
  const screen = location.pathname;
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [croppedImage, setCroppedImage] = useState<HTMLImageElement | null>(null);
  const [open, setOpen] = useState(false);
  const [showContractsModal, setShowContractsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState<UserDataType>({} as UserDataType);

  const dispatch = useDispatch();

  const { uploadUserImage, loading } = useProfilePhoto();

  const isLastItemMenu = (item: string) => item === itemsMenu[itemsMenu.length - 1].item;
  const { token } = useSelector((state: any) => state.auth);

  useEffect(() => {
    (async () => {
      if (token) {
        await getUserData();
      }
    })();
  }, [token, dispatch]);

  useEffect(() => {
    if (user?.foto) {
      //get image from config.s3Url + user?.foto convert to image and set to image
      const img = new Image();
      img.src = config.s3Url + user?.foto;
      img.onload = () => {
        if (img.width > 550) {
          img.height = (550 * img.height) / img.width;
          img.width = 550;
        }
        img.decode();
        setImage(img);
      };
    }
    // eslint-disable-next-line
  }, [dispatch, user?.foto]);

  const getUserData = async () => {
    setIsLoading(true);
    try {
      const dataLocal = JSON.parse(localStorage.getItem('persist:root') || '{}');
      if (dataLocal) {
        const {
          user: { id },
        } = JSON.parse(dataLocal.auth || '{}');

        const userFromApi = await fetchById(id);
        setUser(userFromApi);
      }
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveUserData = (values: UserDataType) => {
    const { foto, ...newValues } = values;
    const valuesSend = { ...newValues, id: user?.id_usuario };
    dispatch(
      studentActions.editStudent(valuesSend, async () => {
        await getUserData();
      })
    );
  };

  const handleSavePasswordUser = (values: UserPassWordDataType) => {
    const valuesSend = {
      ...values,
      userId: user?.id_usuario,
    };
    dispatch(
      studentActions.changePassword(valuesSend, async () => {
        await getUserData();
      })
    );
  };

  if (isLoading && firstLoading.current) {
    firstLoading.current = false;
    return <Loading />;
  }

  const handleSetImage = async (e: ChangeEvent<HTMLInputElement>) => {
    setImage(null);

    if (e.target.files) {
      const file = e.target.files;
      let img = new Image();
      img.src = URL.createObjectURL(file[0]);
      img.onload = () => {
        if (img.width > 550) {
          img.height = (550 * img.height) / img.width;
          img.width = 550;
        }
      };
      await img.decode();
      setImage(img);
      setOpen(true);
    }
  };

  const closeModal = () => setOpen(false);

  const handleUploadUserImage = async () => {
    await uploadUserImage(
      croppedImage as HTMLImageElement,
      token,
      String(user?.id_usuario),
      async () => {
        await getUserData();
        setOpen(false);
        setImage(null);
        setCroppedImage(null);
      }
    );
  };

  return (
    <MainLayout title="Meu perfil" className="home">
      <Container>
        <HeaderInside title="Meu perfil" subtitle="Configure sua conta" />
        <Panel>
          <LeftBar>
            {itemsMenu.map(({ item, label, link, isModal }: MenuItem, index: number) => (
              <MenuItems
                key={item}
                isLastItem={isLastItemMenu(item)}
                isFirstItem={index === 0}
                isSelected={!isModal && link === screen}
                href={isModal ? undefined : link ?? undefined}
                onClick={isModal ? (e: React.MouseEvent) => { e.preventDefault(); setShowContractsModal(true); } : undefined}
              >
                <p>{label}</p>
                <ArrowRight width={28} color="#3f4cbd" />
              </MenuItems>
            ))}
            <ButtonDeleteMenuArea>
              <ButtonDeleteAccount href={linkRedirectWhatsappDeleteAccount} target="_blank">
                Deletar minha conta
              </ButtonDeleteAccount>
            </ButtonDeleteMenuArea>
          </LeftBar>
          <RightArea>
            {screen === '/user' ? (
              <>
                <TitleItem>Dados pessoais</TitleItem>
                <input
                  type="file"
                  onChange={(e) => handleSetImage(e)}
                  style={{ visibility: 'hidden' }}
                  id="input-file"
                />
                <AvatarArea onClick={() => document.getElementById('input-file')?.click()}>
                  {user?.foto ? (
                    <img src={config.s3Url + user?.foto} alt="avatar" />
                  ) : (
                    <NameLetterIcon>{user?.nome?.slice(0, 1)}</NameLetterIcon>
                  )}
                  <EditAvatarItem>
                    <EditPen width={16} />
                  </EditAvatarItem>
                </AvatarArea>
                {user?.id_usuario ? (
                  <FormRegister handleSaveUserData={handleSaveUserData} user={user} />
                ) : null}
              </>
            ) : (
              <>
                <TitleItem>Senha</TitleItem>
                <FormPassword
                  dataPassword={{ nova_senha: '', reNewPassword: '', senha_atual: '' }}
                  handleSavePasswordUser={handleSavePasswordUser}
                />
              </>
            )}
          </RightArea>
        </Panel>
      </Container>
      <ButtonDeleteFooterArea>
        <ButtonDeleteAccount href={linkRedirectWhatsappDeleteAccount} target="_blank">
          Deletar minha conta
        </ButtonDeleteAccount>
      </ButtonDeleteFooterArea>

      <Modal
        isOpen={open}
        ariaHideApp={false}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Modal Editar Foto"
      >
        <ModalUploadProfilePhoto>
          <HeaderModalProfilePhoto>
            <h2>
              Editar foto
              <span>(Você pode cortar sua foto ou somente clicar em salvar)</span>
            </h2>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
              }}
            >
              <img src={times} alt="Fechar" />
            </button>
          </HeaderModalProfilePhoto>
          <Cropped
            image={image}
            getImageCropped={(img) => {
              setCroppedImage(img);
            }}
          />

          <ButtonsArea>
            <ButtonSave type="button" onClick={handleUploadUserImage}>
              {loading ? <ClipLoader color="#fff" size={20} /> : 'Salvar'}
            </ButtonSave>
            <ButtonCancel type="button" onClick={closeModal}>
              Cancelar
            </ButtonCancel>
          </ButtonsArea>
        </ModalUploadProfilePhoto>
      </Modal>

      {showContractsModal && <ContractsModal setVisible={setShowContractsModal} />}
    </MainLayout>
  );
}

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    zIndex: 99,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: 'transparent',
    zIndex: 999,
  },
};

export default connect()(User);
